import React from 'react';
import img2 from '../../images/6M513.png'

const NotFound = () => {
    return (
        <div>
            <img src={img2} alt="" />
        </div>
    );
};

export default NotFound;